import React, { useState, useRef } from 'react'
import styles from './index.module.scss'
import { Select, Button } from 'antd'

interface IAddress {
  lat: number | null
  lng: number | null
  addr: string
}

const { Option } = Select

export default function XdragonApi() {
  const [address, setAddress] = useState<IAddress>({
    lat: null,
    lng: null,
    addr: '',
  })

  const [type, setType] = useState('team')

  const tidInputRef = useRef<HTMLInputElement>(null)

  const navLatRef = useRef<HTMLInputElement>(null)
  const navLngRef = useRef<HTMLInputElement>(null)
  const navAddressRef = useRef<HTMLInputElement>(null)


  const handleChangeType = (value) => {
    setType(value)
  }

  const handleLinkToDrgon = (e) => {
    e.stopPropagation()

    const tid = tidInputRef?.current?.value || ''

    console.log('tid ----->', tid)
    console.log('type ----->', type)

    if (tid.trim().length === 0) {
      return
    }

    if (window.xdragon) {
      console.log('执行跳转骁龙 IM --->')

      try {
        window.xdragon.callHandler('sendMessage', {
          accId: Number(tid),
          type: type,
        })
      } catch {
        console.log('跳转骁龙失败--->')
      }
    }
  }

  const handleNav = (e) => {
    e.stopPropagation()

    const lat = navLatRef?.current?.value || ''
    const lng = navLngRef?.current?.value || ''
    const addr = navAddressRef?.current?.value || ''

    console.log('lat ----->', lat)
    console.log('lng ----->', lng)
    console.log('addr ----->', addr)

    if (
      lat.trim().length === 0 ||
      lng.trim().length === 0 ||
      addr.trim().length === 0
    ) {
      return
    }

    if (window.xdragon) {
      console.log('执行调起导航的操作 --->')
      try {
        window.xdragon.callHandler('openMap', {
          lat: Number(lat),
          lng: Number(lng),
          addr: addr,
        })
      } catch {
        console.log('调起导航失败--->')
      }
    }
  }

  const handleLocatin = () => {
    if (window.xdragon) {
      window.xdragon
        .callHandler('getCurrentLocation', {})
        .then((res) => {
          console.log('获取定位成功 --->', res)
          if (res.error) {
            throw new Error(res.error)
          }
          if (res.data) {
            setAddress(res.data)
          }
        })
        .catch((err) => {
          console.log('获取定位失败 --->', err)
          console.log(err)
        })
    }
  }

  return (
    <div className={styles.pageWrap}>
      <h1 className={styles.pageTitle}>骁龙 API 测试</h1>
      <div className={styles.blockWrap}>
        <h3>跳转 IM会话</h3>
        <div className={styles.inputWrap}>
          <input type="number" ref={tidInputRef} />
        </div>
        <div className={styles.inputWrap}>
          <Select
            value={type}
            style={{ width: '100%' }}
            onChange={handleChangeType}
          >
            <Option value="p2p">p2p</Option>
            <Option value="team">team</Option>
          </Select>
        </div>
        <Button type="primary" block onClick={handleLinkToDrgon}>
          跳转
        </Button>
      </div>

      <div className={styles.blockWrap}>
        <h3>调起地图APP导航</h3>
        <div className={styles.inputWrap}>
          <label htmlFor="navLatRef">纬度</label>
          <input
            id="navLatRef"
            type="number"
            defaultValue={37.499436}
            ref={navLatRef}
          />
        </div>
        <div className={styles.inputWrap}>
          <label htmlFor="navLngRef">经度</label>
          <input
            type="number"
            id="navLngRef"
            defaultValue={116.473083}
            ref={navLngRef}
          />
        </div>
        <div className={styles.inputWrap}>
          <label htmlFor="navAddressRef">地址</label>
          <input
            type="text"
            id="navAddressRef"
            defaultValue={'北京市朝阳区阜荣街10号'}
            ref={navAddressRef}
          />
        </div>
        <Button type="primary" block onClick={handleNav}>
          调起地图
        </Button>
      </div>

      <div className={styles.blockWrap}>
        <h3>获取当前定位信息</h3>
        <Button type="primary" block onClick={handleLocatin}>
          获取当前定位
        </Button>
        {(address.lat || address.lng || address.addr) && (
          <div className={styles.resultWrap}>
            <h3>结果</h3>
            <p>lat: {address.lat}</p>
            <p>lng: {address.lng}</p>
            <p>addr: {address.addr}</p>
          </div>
        )}
      </div>
    </div>
  )
}
